"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskPhoneNum = exports.unmaskPhone = void 0;
const unmaskPhone = (number) => number.replace(/\D/g, "");
exports.unmaskPhone = unmaskPhone;
const maskPhoneNum = (number) => {
    const cleanString = (0, exports.unmaskPhone)(number);
    if (!cleanString) {
        return "";
    }
    const areaCode = cleanString.substring(0, 3);
    const partTwo = cleanString.substring(3, 6);
    const partThree = cleanString.substring(6);
    return `(${areaCode}${partTwo ? ") " : ""}${partTwo}${partThree ? "-" : ""}${partThree}`;
};
exports.maskPhoneNum = maskPhoneNum;
//# sourceMappingURL=maskPhoneNum.js.map